export enum Paths {
  AUTOMATIC = '/automatic',
  AUTOMATIC_BUY = '/automatic/buy',
  AUTOMATIC_BUY_CONFIRM = '/automatic/buy/confirm',
  AUTOMATIC_BUY_EDIT = '/automatic/buy/edit',
  AUTOMATIC_BUY_EDIT_CONFIRM = '/automatic/buy/edit/confirm',
  AUTOMATIC_CONTRIBUTE = '/automatic/contribute',
  AUTOMATIC_CONTRIBUTE_CONFIRM = '/automatic/contribute/confirm',
  AUTOMATIC_CONTRIBUTE_EDIT = '/automatic/contribute/edit',
  AUTOMATIC_CONTRIBUTE_EDIT_CONFIRM = '/automatic/contribute/edit/confirm',
  AUTOMATIC_EXCHANGE = '/automatic/exchange',
  AUTOMATIC_EXCHANGE_CONFIRM = '/automatic/exchange/confirm',
  BUY = '/buy',
  BUY_CONFIRM = '/buy/confirm',
  COLLEGE_CONTRIBUTE = '/college/contribute',
  COLLEGE_CONTRIBUTE_CONFIRM = '/college/contribute/confirm',
  COLLEGE_DISTRIBUTE = '/college/distribute',
  COLLEGE_DISTRIBUTE_CONFIRM = '/college/distribute/confirm',
  COLLEGE_EXCHANGE = '/college/exchange',
  COLLEGE_EXCHANGE_CONFIRM = '/college/exchange/confirm',
  EXCHANGE = '/exchange',
  EXCHANGE_CONFIRM = '/exchange/confirm',
  LANDING = '/landing',
  SELL = '/sell',
  SELL_CONFIRM = '/sell/confirm',
  QCD = '/qcd',
  QCD_LANDING = '/qcd/landing',
}
